import { useState } from "react";
import {
  getIssuerApi,
  updateIssuerApi,
  getSeriesApi,
  addSeriesApi,
  updateSeriesApi,
  emitComprobanteApi,
  getComprobantesApi,
  downloadComprobantePdfApi,
  lookupDocumentApi,
} from "../api/invoicing";
import { useAuth } from "./";

export function useInvoicing() {
  const [loading, setLoading] = useState(false);
  const [issuer, setIssuer] = useState(null);
  const [series, setSeries] = useState([]);
  const [comprobantes, setComprobantes] = useState([]);
  const { auth } = useAuth();
  const token = auth?.token;

  const getIssuer = async () => {
    try {
      setIssuer(await getIssuerApi(token));
    } catch (error) {
      setIssuer(null);
    }
  };

  const updateIssuer = async (data) => {
    const response = await updateIssuerApi(data, token);
    setIssuer(response);
    return response;
  };

  const getSeries = async () => {
    try {
      setLoading(true);
      setSeries(await getSeriesApi(token));
    } finally {
      setLoading(false);
    }
  };

  const addSeries = async (data) => {
    await addSeriesApi(data, token);
    await getSeries();
  };

  const updateSeries = async (id, data) => {
    await updateSeriesApi(id, data, token);
    await getSeries();
  };

  const emitComprobante = (paymentId, docType, summarized = false) =>
    emitComprobanteApi(paymentId, docType, token, summarized);

  const getComprobantes = async (params) => {
    try {
      setLoading(true);
      setComprobantes(await getComprobantesApi(params, token));
    } finally {
      setLoading(false);
    }
  };

  const downloadComprobantePdf = (comprobante) => downloadComprobantePdfApi(comprobante, token);

  const lookupDocument = (docType, docNumber) => lookupDocumentApi(docType, docNumber, token);

  return {
    loading,
    issuer,
    series,
    comprobantes,
    getIssuer,
    updateIssuer,
    getSeries,
    addSeries,
    updateSeries,
    emitComprobante,
    getComprobantes,
    downloadComprobantePdf,
    lookupDocument,
  };
}
